__turbopack_context__.v({
  "className": "poppins_27e9c9cc-module__mDGjGW__className",
  "variable": "poppins_27e9c9cc-module__mDGjGW__variable",
});
